import { Observable } from "../observable";
import "./gallery.css";

class GalleryElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const imgs: HTMLElement[] = [];
        for (const childNode of this.childNodes) {
            if (childNode instanceof HTMLElement) {
                imgs.push(childNode);
            }
        }

        this.innerHTML = "";

        const $index = new Observable(0);

        const viewer = document.createElement("div");
        viewer.className = "viewer";

        const nextButton = document.createElement("button");
        nextButton.className = "bd-button icon surface-20 next-button";
        nextButton.onclick = () => {
            $index.broadcast((prev) => Math.min(prev + 1, imgs.length - 1));
        };

        const prevButton = document.createElement("button");
        prevButton.className = "bd-button icon surface-20 prev-button";
        prevButton.onclick = () => {
            $index.broadcast((prev) => Math.max(prev - 1, 0));
        };

        this.appendChild(prevButton);
        this.appendChild(nextButton);
        this.appendChild(viewer);

        $index.subscribe((index) => {
            nextButton.innerHTML = `<bd-icon value="nav-arrow-right"></bd-icon>`;
            nextButton.disabled = index === imgs.length - 1;

            prevButton.innerHTML = `<bd-icon value="nav-arrow-left"></bd-icon>`;
            prevButton.disabled = index === 0;

            viewer.innerHTML = "";
            viewer.appendChild(imgs[index]);
        }, true);
    }
}

customElements.define("bd-gallery", GalleryElement);
